import { downloadInsertionOrder } from "actions/insertionOrder";
import React, { useRef, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import NotificationAlert from "react-notification-alert";

const DocumentPreviewModal = ({ isOpen, toggle, document }) => {
  const [loading, setLoading] = useState(true);
  const notificationAlertRef = useRef(null);
  const notify = (type, message) => {
    notificationAlertRef.current.notificationAlert({
      place: "tr",
      message: <div>{message}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    });
  };

  if (!document) return null;

  const { name, mediaPath, ID } = document;
  const ext = mediaPath?.split(".")?.pop().toLowerCase();
  const isPdf = ext === "pdf";

  const getViewerUrl = () => {
    if (isPdf) return mediaPath;

    return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
      mediaPath,
    )}`;
  };

  const handleDownload = () => {
    const a = window.mediaPath.createElement("a");
    a.href = mediaPath;
    a.download = name;
    window.mediaPath.body.appendChild(a);
    a.click();
    window.mediaPath.body.removeChild(a);
  };

  const downloadPdf = (pdfString) => {
    const blob = new Blob([pdfString], { type: "application/pdf" });

    const url = window.URL.createObjectURL(blob);
    const link = window.document.createElement("a");

    link.href = url;
    link.download = name || "document.pdf";

    window.document.body.appendChild(link);
    link.click();

    window.document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const downloadIoDocument = async () => {
    try {
      const res = await downloadInsertionOrder(ID);
      if (res?.code == 500 || res?.code === 404) {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      } else {
        downloadPdf(res);
      }
    } catch (error) {}
  };

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <Modal isOpen={isOpen} toggle={toggle} size="xl" centered>
        <ModalHeader toggle={toggle}>{name}</ModalHeader>

        <ModalBody style={{ height: "75vh", padding: 0 }}>
          {loading && (
            <div className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center">
              <i className="fa fa-spinner fa-spin fa-2x text-muted" />
            </div>
          )}

          {!isPdf && (
            <iframe
              src={getViewerUrl()}
              title={name}
              className="w-100 h-100 border-0"
              onLoad={() => setLoading(false)}
            />
          )}
          {isPdf && (
            <embed
              src={getViewerUrl()}
              type="application/pdf"
              className="w-100 h-100"
              onLoad={() => setLoading(false)}
            />
          )}
        </ModalBody>

        <ModalFooter className="justify-content-end">
          <Button
            className="btn-gradient-primary"
            // outline
            onClick={downloadIoDocument}
          >
            <i className="fa fa-download mr-2" />
            Download
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default DocumentPreviewModal;
